import { render, staticRenderFns } from "./contatoModal.vue?vue&type=template&id=eff83cc6&"
import script from "./contatoModal.vue?vue&type=script&lang=js&"
export * from "./contatoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports